# GraphQL query to get a stageset by id, that contains
# some basic information about itself along with its relevant stages

#import "../fragments/sales-automation-stageset.graphql"

query StagesetAndStages($stagesetId: ID!) {
    stageset(id: $stagesetId) {
        ...SalesAutomationStageset
    }
    hasMailChimpIntegration
    hasConstantContactIntegration
    hasSlackIntegration
}
